/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const state = {
  rubriks: {},
};

export const mutations = {
  SET_RUBRIKS(state, newValue) {
    state.rubriks = Object.assign({}, state.rubriks, newValue);
  },
};

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`psp/i/${id}/pelatihan/imbas-nilai?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async rubrik({ rootState, state, commit }, payloads) {
    const id = rootState.auth.instansi_id;
    const kelompok = payloads.kelompok;

    if (state.rubriks[kelompok]) {
      return state.rubriks[kelompok];
    }

    const resp = await http
      .get(`psp/i/${id}/pelatihan/imbas-nilai/rubrik?kelompok=${kelompok}`)
      .then(({ data }) => data);

    let kelompokBaru = {};
    kelompokBaru[kelompok] = resp;

    commit('SET_RUBRIKS', kelompokBaru);

    return resp;
  },

  async peserta({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http
      .get(`psp/i/${id}/pelatihan/imbas-nilai/${payload.id}/kelas?${queryString(payload.params)}`)
      .then(({ data }) => data);
  },

  async pesertaNilai({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`psp/i/${id}/pelatihan/imbas-nilai/${payload.id}/fetch`).then(({ data }) => data);
  },

  save({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/pelatihan/imbas-nilai/${payload.id}/save`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  reset({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `psp/i/${id}/pelatihan/imbas-nilai/${payload.id}/reset`;
    return http.post(url, payload.params).then(({ data }) => data);
  },

  downloadList({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    const url = `${process.env.VUE_APP_API_URL}/psp/i/${id}/peserta/${payload.type}/${payload.url}?${queryString(
      payload.params
    )}`;
    return Promise.resolve(url);
  },
};
